export const controlArrowSizesRem = {
  '24': '1.5rem',
  '40': '2.5rem',
}

export const controlArrowIconSizesRem = {
  '24': {
    width: '0.3rem',
    height: '0.525rem',
  },
  '40': {
    width: '0.5rem',
    height: '0.875rem',
  },
}

export const controlArrowSizesPx = {
  '24': '24px',
  '40': '40px',
}

export const controlArrowIconSizesPx = {
  '24': {
    width: '4.8px',
    height: '8.4px',
  },
  '40': {
    width: '8px',
    height: '14px',
  },
}
